export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validateUsername = (username) => {
  return username.length >= 3 && username.length <= 20;
};

export const validatePassword = (password) => {
  return password.length >= 8;
};
